"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _Icon = require("./Icon.styles");
require("../../assets/fonts/style.css");
var _theme = require("../utils/theme");
var _excluded = ["theme", "children", "color", "size", "icon", "className"];
var Icon = function Icon(_ref) {
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? _theme.defaultTheme : _ref$theme,
    children = _ref.children,
    color = _ref.color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '30' : _ref$size,
    icon = _ref.icon,
    className = _ref.className,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_Icon.PlainIcon, (0, _extends2["default"])({
    color: color,
    size: size,
    icon: icon,
    className: "icon-".concat(icon, " ").concat(className)
  }, props)));
};
var _default = exports["default"] = Icon;